import { defineRequest } from "@/lib/fetch-tools";
import { RequestResponse } from "./types";

export const apiGoldKlineData = defineRequest<
  RequestResponse<{
    code: string;
    kline_type: number;
    kline_list: Array<{
      timestamp: string;
      open_price: string;
      close_price: string;
      high_price: string;
      low_price: string;
      volume: string;
      turnover: string;
    }>;
  }>,
  {
    query: string;
    token: string;
  }
>("/quote-b-api/kline", {
  baseUrl: "/",
});
